import React, { useState, useEffect } from "react";
import { useCartData } from "@/zustand/cartStore.js";
import ProductSelectorButton from "@/components/ProductSelectorButton";

const VariantOptionRadio = ({ handleClick, label, type, sku, size, color }) => {
  const [active, setActive] = useState();
  const { variants } = useCartData();

  useEffect(() => {
    if (variants) {
      setActive(type == "color" ? variants[0]?.color?.toLowerCase() === sku : variants[0]?.size?.toLowerCase() === sku);
    }
  }, [variants]);

  return (
    <li
      className={`custom-radio--item ${active && "custom-radio--item--active"} custom-radio--item--${size}`}
      onClick={() => {
        handleClick(sku, label);
      }}
    >
      <div className="custom-radio--item__wrapper">
        <ProductSelectorButton />
        {type === "color" && (
          <div className="custom-select__colorIndicator" style={{ background: color ? color : "#000" }}></div>
        )}
        {label && <span>{label}</span>}
      </div>
    </li>
  );
};

export default VariantOptionRadio;
